import { useHistory } from 'react-router-dom';
import { OpenUrlFn, OpenUrlOptions, GeneralRouteFn } from './interface';


export const URLSearchParams = window.URLSearchParams;

export const useNavigate = (getRouteUrl: GeneralRouteFn<string>): GeneralRouteFn<void> => {
  const history = useHistory();
  const navigate = (name: string, params?: object) => {
    const url = getRouteUrl(name, params);
    history.push(url);
  };

  return navigate;
};

export const openUrl: OpenUrlFn = (url: string, options?: OpenUrlOptions) => {
  window.open(url, options?.method?.$web === 'same-tab' ? '_self' : '_blank');
};
